import { cn } from "@/lib/utils";
import { useReveal } from "@/hooks/use-reveal";
import type { CSSProperties, ElementType, ReactNode } from "react";

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  as?: ElementType;
  style?: CSSProperties;
}

/** Wraps children with a scroll-triggered fade + upward reveal animation. */
export function Reveal({ children, className, delay = 0, as: Tag = "div", style }: RevealProps) {
  const { ref, visible } = useReveal<HTMLElement>();

  return (
    <Tag
      ref={ref}
      className={cn("reveal", visible && "reveal-visible", className)}
      style={{ ...style, transitionDelay: visible ? `${delay}ms` : "0ms" }}
    >
      {children}
    </Tag>
  );
}

